document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll(
        '[incore-permission-type]:not(.permok)'
    );

    elements.forEach(el => {
        InCoreCheckPermission(el);
    });
});

document.addEventListener("shown.bs.dropdown", (event: Event) => {
    const button = event.target as HTMLElement;

    const dropdown = button.closest(".dropdown");

    console.log(dropdown);

    if (dropdown) {
        const elements = dropdown.querySelectorAll(
            '[incore-permission-type]'
        );

        elements.forEach(el => {
            InCoreCheckPermission(el);
        });
    }
});

document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    const dropdown = target.closest(".dropdown");

    if (dropdown) {
        // Delay slightly to let DOM render menu
        setTimeout(() => {
            const elements = dropdown.querySelectorAll(
                '[incore-permission-type]'
            );

            elements.forEach(el => {
                InCoreCheckPermission(el);
            });
        }, 50);
    }
});

export async function InCoreCheckPermission(el: Element): Promise<void> {
    try {
        console.log(el);

        const permissionType = el.getAttribute("incore-permission-type");
        const permissionValue = el.getAttribute("incore-permission-value");

        if (permissionType) {
            
            const hasPermission = await InCoreHasPermission(permissionType, permissionValue ?? "");

            if (hasPermission) {
                console.log("User HAS permission");
            } else {
                console.log("User DOES NOT have permission");
                el.remove();
            }

        }
    } catch (error) {
        console.error("Error calling CheckPermission:", error);
    }
}

export async function InCoreHasPermission(
    permissionType: string,
    permissionValue?: string
): Promise<boolean> {
    try {
        const url = `/Home/CheckPermission` +
            `?PermissionType=${encodeURIComponent(permissionType)}` +
            `&PermissionValue=${encodeURIComponent(permissionValue ?? "")}`;

        const response = await fetch(url, {
            method: "GET"
        });

        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        const result = await response.text();

        return result === "true";
    } catch (error) {
        console.error("Error calling CheckPermission:", error);
        return false;
    }
}
const permissionsCache: Record<string, boolean> = {};

export async function LoadActionsPermissions(actions: any): Promise<void> {
    const checks: Promise<void>[] = [];

    actions.getActions().forEach((act: any) => {

        if (!act.permissionType && !act.permissionValue) {
            return; 
        }

        const key = `${act.permissionType}|${act.permissionValue}`;

        if (permissionsCache[key] !== undefined)
            return;

        checks.push(
            InCoreHasPermission(
                act.permissionType ?? "",
                act.permissionValue ?? ""
            ).then(result => {

                permissionsCache[key] = result;

            })
        );
    });

    await Promise.all(checks);
}

export function GetPermissionCached(
    permissionType: string,
    permissionValue: string
): boolean {

    const key = `${permissionType}|${permissionValue}`;

    return permissionsCache[key] ?? false;
}